import React from "react";
import { useNavigate } from "react-router-dom";
import "../assets/css/pages.css";

const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "Solutions", path: "/solutions" },
  { label: "Expertise", path: "/expertise" },
  { label: "About", path: "/about" },
  { label: "News & Events", path: "/news" },
  { label: "Careers", path: "/careers" },
  { label: "Locations", path: "/locations" },
  { label: "Contact", path: "/contact" },
];

const SERVICES = [
  "Clinical Trial Management",
  "Regulatory Consulting",
  "Medical Writing",
  "GCP Training",
  "Audit Support",
  "Archival of Clinical Data",
];

export default function Footer() {
  const navigate = useNavigate();
  const go = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <footer className="ft-root">
      <div className="ft-inner">
        {/* ── Top grid ── */}
        <div className="ft-grid">
          {/* Brand */}
          <div className="ft-brand">
            <p className="ft-brand__desc">
              Advancing Clinical Excellence with Integrity, Compliance, and
              Precision. India's premier Site Management Organisation.
            </p>
            <div className="ft-socials">
              <a
                href="mailto:acceliaclinicalsolution@gmail.com"
                className="ft-social"
                aria-label="Email"
              >
                <svg
                  width="16"
                  height="16"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="1.8"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
              </a>
              <a
                href="tel:+918282986162"
                className="ft-social"
                aria-label="Phone"
              >
                <svg
                  width="16"
                  height="16"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="1.8"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noreferrer"
                className="ft-social"
                aria-label="LinkedIn"
              >
                <svg
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z" />
                  <circle cx="4" cy="4" r="2" />
                </svg>
              </a>
            </div>
          </div>

          {/* Navigate */}
          <div className="ft-col">
            <h4 className="ft-col__heading">Navigate</h4>
            {NAV_LINKS.map(({ label, path }) => (
              <button key={path} className="ft-link" onClick={() => go(path)}>
                {label}
              </button>
            ))}
          </div>

          {/* Services */}
          <div className="ft-col">
            <h4 className="ft-col__heading">Services</h4>
            {SERVICES.map((s) => (
              <button
                key={s}
                className="ft-link"
                onClick={() => go("/solutions")}
              >
                {s}
              </button>
            ))}
          </div>

          {/* Contact */}
          <div className="ft-col">
            <h4 className="ft-col__heading">Contact</h4>
            <a
              href="mailto:acceliaclinicalsolution@gmail.com"
              className="ft-link ft-contact-item"
            >
              <span className="ft-contact-icon">📧</span>
              acceliaclinicalsolution@gmail.com
            </a>
            <a href="tel:+918282986162" className="ft-link ft-contact-item">
              <span className="ft-contact-icon">📞</span>
              +91 8282986162
            </a>
            <button
              className="ft-link ft-contact-item"
              onClick={() => go("/locations")}
            >
              <span className="ft-contact-icon">📍</span>
              Kolkata (HQ), West Bengal
            </button>
          </div>
        </div>

        {/* ── Divider ── */}
        <div className="ft-divider" />

        {/* ── Bottom bar ── */}
        <div className="ft-bottom">
          <span className="ft-copy">
            © 2026{" "}
            <span className="ft-copy__brand">Accelia Clinical Solutions</span>.
            All rights reserved.
          </span>
          <div className="ft-bottom__links">
            <button className="ft-bottom__link" onClick={() => go("/contact")}>
              Privacy Policy
            </button>
            <span className="ft-bottom__dot">·</span>
            <button className="ft-bottom__link" onClick={() => go("/contact")}>
              Terms of Use
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
